module.exports = {
  REDIRECT_INIT: 'REDIRECT_INIT',
  REDIRECT_DONE: 'REDIRECT_DONE',
  UPDATE_BLOCK_ROUTING: 'BLOCK_ROUTING',
  NOTIFY_USER_ROUTE_BLOCKED: 'NOTIFY_USER_ROUTE_BLOCKED',
  USER_CONFIRMS_TO_CHANGE_ROUTE: 'USER_CONFIRMS_TO_CHANGE_ROUTE',
};
